import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { 
    ArrowLeft, 
    Smartphone, 
    Monitor, 
    ExternalLink, 
    Loader2, 
    AlertCircle 
} from 'lucide-react';
import PublicView from './PublicView'; // Reaproveitamos o componente real
import toast from 'react-hot-toast';

const PreviewCardapio = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [device, setDevice] = useState('mobile'); // mobile | desktop
    const [loading, setLoading] = useState(true);
    const [exists, setExists] = useState(false);

    useEffect(() => {
        const verificarLink = async () => {
            try {
                // Verifica se o estabelecimento existe antes de renderizar o preview
                const res = await api.get(`/cardapio/view/${slug}`);
                if (res.data) {
                    setExists(true);
                }
            } catch (err) {
                setExists(false);
                toast.error("Cardápio não encontrado para este link.");
            } finally {
                setLoading(false);
            }
        };
        verificarLink();
    }, [slug]);

    if (loading) {
        return (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
                <Loader2 className="animate-spin" size={40} color="#ea1d2c" />
                <p style={{ marginTop: '15px', color: '#64748b', fontWeight: 'bold' }}>Carregando Visualização...</p>
            </div>
        );
    }

    if (!exists) {
        return (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '20px' }}>
                <AlertCircle size={60} color="#94a3b8" />
                <h2 style={{ marginTop: '20px', color: '#1e293b' }}>Ops! Cardápio não localizado.</h2>
                <p style={{ color: '#64748b' }}>Verifique se o slug <strong>{slug}</strong> está correto no seu painel.</p>
                <button onClick={() => navigate(-1)} style={{ marginTop: '20px', padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#ea1d2c', color: '#fff', cursor: 'pointer' }}>
                    Voltar ao Painel
                </button>
            </div>
        );
    }

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#1e293b' }}>
            {/* BARRA DE FERRAMENTAS DO PREVIEW */}
            <header style={{ height: '60px', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', borderBottom: '1px solid #334155' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <ArrowLeft size={18} /> Sair do Preview
                    </button>
                    <div style={{ width: '1px', height: '24px', background: '#334155' }}></div>
                    <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>Visualizando: <span style={{ color: '#38bdf8' }}>/{slug}</span></span>
                </div>

                <div style={{ display: 'flex', background: '#1e293b', borderRadius: '8px', padding: '4px' }}>
                    <button 
                        onClick={() => setDevice('mobile')}
                        style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', background: device === 'mobile' ? '#334155' : 'transparent', color: '#fff' }}
                        title="Ver no Celular"
                    >
                        <Smartphone size={18} />
                    </button>
                    <button 
                        onClick={() => setDevice('desktop')}
                        style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', background: device === 'desktop' ? '#334155' : 'transparent', color: '#fff' }}
                        title="Ver no Computador"
                    >
                        <Monitor size={18} />
                    </button>
                </div>

                <a href={`/v/${slug}`} target="_blank" rel="noreferrer" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Abrir link oficial <ExternalLink size={14} />
                </a>
            </header>

            {/* ÁREA DE RENDERIZAÇÃO */}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: device === 'mobile' ? '20px' : '0', overflow: 'hidden' }}>
                <div style={{ 
                    width: device === 'mobile' ? '375px' : '100%', 
                    height: device === 'mobile' ? '760px' : '100%', 
                    background: '#fff',
                    borderRadius: device === 'mobile' ? '30px' : '0',
                    border: device === 'mobile' ? '8px solid #334155' : 'none',
                    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
                    position: 'relative',
                    overflowY: 'auto',
                    transition: 'all 0.3s ease'
                }}>
                    {/* Renderiza o seu componente PublicView real dentro do frame */}
                    <PublicView />
                </div>
            </div>
        </div>
    );
};

export default PreviewCardapio;